// Modal: salida del embudo. Genera la solicitud y migra a cliente, atómico.
import React, { useState, useEffect } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import { useHistory } from "react-router-dom";

const BASE = process.env.REACT_APP_API_BASE || "http://localhost/twinpack/php";

const ProspeccionGenerarSolicitudModal = ({ prospecto, contactos = [], userId, onClose }) => {
  const history = useHistory();
  const [contactosATildados, setContactosATildados] = useState(
    () => new Set(contactos.map((c) => parseInt(c.id, 10)))
  );
  const [contactoSolicitudId, setContactoSolicitudId] = useState(
    () => (contactos.find((c) => c.es_principal == 1 || c.es_principal === "1")?.id || contactos[0]?.id || "")
  );
  const [proveedorId, setProveedorId] = useState("");
  const [observaciones, setObservaciones] = useState(() => {
    // Pre-cargar con la ficha
    const partes = [];
    if (prospecto.ficha_que_les_interesa)   partes.push(`Qué les interesa: ${prospecto.ficha_que_les_interesa}`);
    if (prospecto.ficha_a_quien_le_compran) partes.push(`A quién le compran: ${prospecto.ficha_a_quien_le_compran}`);
    if (prospecto.ficha_oportunidad)        partes.push(`Oportunidad: ${prospecto.ficha_oportunidad}`);
    if (prospecto.ficha_con_quien_hablo)    partes.push(`Contacto clave: ${prospecto.ficha_con_quien_hablo}`);
    return partes.join("\n");
  });
  const [proveedores, setProveedores] = useState([]);
  const [submitting, setSubmitting]   = useState(false);

  useEffect(() => {
    axios.get(`${BASE}/buscar_terceros.php`)
      .then((r) => {
        if (Array.isArray(r.data)) {
          setProveedores(r.data.filter((t) => t.tipo_other === 3));
        }
      })
      .catch(() => {});
  }, []);

  const toggleContacto = (id) => {
    const n = new Set(contactosATildados);
    if (n.has(id)) n.delete(id); else n.add(id);
    setContactosATildados(n);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!userId) return toast.error("No se detectó el usuario");
    setSubmitting(true);
    try {
      const fd = new FormData();
      fd.append("prospecto_id", prospecto.id);
      fd.append("user_id", userId);
      if (contactoSolicitudId) fd.append("contacto_id_solicitud", contactoSolicitudId);
      if (proveedorId)         fd.append("proveedor_id", proveedorId);
      if (observaciones)       fd.append("observaciones", observaciones);
      Array.from(contactosATildados).forEach((cid) => fd.append("contactos_a_migrar[]", cid));

      const r = await axios.post(`${BASE}/prospectos_generar_solicitud.php`, fd);
      if (r.data?.success) {
        toast.success("✓ Cliente creado y solicitud generada");
        history.push("/dashboard/cotizaciones/solicitudes");
      } else {
        toast.error(r.data?.mensaje || "Error al generar solicitud");
        setSubmitting(false);
      }
    } catch {
      toast.error("Error de conexión");
      setSubmitting(false);
    }
  };

  // Texto formateado de ubicación
  const ubicTexto = (() => {
    const partes = [
      prospecto.calle && `${prospecto.calle}${prospecto.numero ? " " + prospecto.numero : ""}`,
      prospecto.ciudad, prospecto.provincia, prospecto.pais,
    ].filter(Boolean);
    return partes.length ? partes.join(", ") : (prospecto.ubicacion || "—");
  })();

  return (
    <div style={overlay} onClick={onClose}>
      <div style={modal} onClick={(e) => e.stopPropagation()}>
        <h2 style={{ margin: "0 0 6px", fontSize: 20, fontWeight: 700, color: "#1d4ed8" }}>
          ✉ Generar solicitud de cotización
        </h2>
        <p style={{ margin: "0 0 18px", color: "#666", fontSize: 13 }}>
          Esto convertirá el prospecto en cliente y creará una solicitud pendiente. Después podés armar la cotización formal desde el listado de solicitudes.
        </p>

        <form onSubmit={handleSubmit}>
          {/* Resumen del cliente que se creará */}
          <div style={{ background: "#f9f5f7", border: "1px solid #f0e6ec", borderRadius: 8, padding: "12px 14px", marginBottom: 16, fontSize: 12 }}>
            <div style={{ fontSize: 10, fontWeight: 700, color: "#888", textTransform: "uppercase", letterSpacing: "0.05em", marginBottom: 6 }}>
              Datos del cliente que se creará
            </div>
            <div style={{ display: "grid", gridTemplateColumns: "auto 1fr", gap: "4px 12px", color: "#444" }}>
              <span style={{ color: "#888" }}>Empresa:</span>   <span>{prospecto.empresa}</span>
              <span style={{ color: "#888" }}>Industria:</span> <span>{prospecto.industria || "—"}</span>
              <span style={{ color: "#888" }}>Segmento:</span>  <span>{prospecto.segmento || "—"}</span>
              <span style={{ color: "#888" }}>Ubicación:</span> <span>{ubicTexto}</span>
            </div>
          </div>

          {/* Datos de la solicitud */}
          <div style={{ fontSize: 11, fontWeight: 700, color: "#9f0059", textTransform: "uppercase", letterSpacing: "0.05em", marginBottom: 10 }}>
            Datos de la solicitud
          </div>

          <Field label="Contacto principal">
            <select style={inp} value={contactoSolicitudId} onChange={(e) => setContactoSolicitudId(e.target.value)}>
              <option value="">—</option>
              {contactos.map((c) => <option key={c.id} value={c.id}>{c.nombre}{c.cargo ? ` · ${c.cargo}` : ""}</option>)}
            </select>
          </Field>

          <Field label="Proveedor (opcional — lo elegís después al armar la cotización)">
            <select style={inp} value={proveedorId} onChange={(e) => setProveedorId(e.target.value)}>
              <option value="">—</option>
              {proveedores.map((p) => <option key={p.id} value={p.id}>{p.tercero}</option>)}
            </select>
          </Field>

          <Field label="Observaciones de la solicitud (pre-cargadas con la ficha — editables)">
            <textarea style={{ ...inp, minHeight: 100, fontFamily: "inherit", resize: "vertical" }}
              value={observaciones} onChange={(e) => setObservaciones(e.target.value)} />
          </Field>

          {/* Contactos a migrar */}
          {contactos.length > 0 && (
            <div style={{ borderTop: "1.5px solid #f0e6ec", paddingTop: 14, marginTop: 14 }}>
              <div style={{ fontSize: 11, fontWeight: 700, color: "#9f0059", textTransform: "uppercase", letterSpacing: "0.05em", marginBottom: 10 }}>
                Contactos a migrar al cliente ({contactosATildados.size} de {contactos.length})
              </div>
              {contactos.map((c) => (
                <label key={c.id} style={{
                  display: "flex", alignItems: "center", gap: 10,
                  padding: "8px 12px", background: "#fafafa", borderRadius: 6,
                  marginBottom: 6, cursor: "pointer", border: "1px solid #f0e6ec",
                }}>
                  <input type="checkbox" checked={contactosATildados.has(parseInt(c.id, 10))}
                    onChange={() => toggleContacto(parseInt(c.id, 10))} />
                  <div style={{ flex: 1 }}>
                    <div style={{ fontSize: 13, fontWeight: 600 }}>
                      {c.es_principal == 1 || c.es_principal === "1" ? "⭐ " : ""}{c.nombre}
                      {c.cargo && <span style={{ color: "#888", fontWeight: 400 }}> · {c.cargo}</span>}
                    </div>
                    {c.email && <div style={{ fontSize: 11, color: "#666" }}>{c.email}</div>}
                  </div>
                </label>
              ))}
            </div>
          )}

          <div style={{ background: "#eff6ff", border: "1px solid #bfdbfe", borderRadius: 8, padding: "10px 14px", marginTop: 14, fontSize: 12, color: "#1e40af" }}>
            ℹ Las interacciones (toques + hitos) se copiarán al historial del cliente con badge "desde prospección".
          </div>

          <div style={{ display: "flex", justifyContent: "flex-end", gap: 10, marginTop: 22 }}>
            <button type="button" onClick={onClose} style={btnSecondary} disabled={submitting}>Cancelar</button>
            <button type="submit" style={btnPrimary} disabled={submitting}>
              {submitting ? "Generando…" : "✉ Confirmar y generar"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

const overlay = { position: "fixed", inset: 0, background: "rgba(0,0,0,0.45)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 1000, padding: 20 };
const modal   = { background: "#fff", borderRadius: 14, padding: "26px 30px", maxWidth: 640, width: "100%", maxHeight: "90vh", overflowY: "auto", boxShadow: "0 8px 32px rgba(0,0,0,0.18)" };
const inp     = { width: "100%", padding: "9px 12px", border: "1.5px solid #e0d6dc", borderRadius: 8, fontSize: 13, color: "#222", background: "#fafafa", outline: "none", boxSizing: "border-box", fontFamily: "inherit" };
const btnPrimary   = { padding: "10px 22px", background: "#1d4ed8", color: "#fff", border: "none", borderRadius: 8, fontSize: 13, fontWeight: 700, cursor: "pointer" };
const btnSecondary = { padding: "10px 22px", background: "#fff", color: "#666", border: "1.5px solid #e0d6dc", borderRadius: 8, fontSize: 13, fontWeight: 600, cursor: "pointer" };
const Field = ({ label, children }) => (
  <div style={{ marginBottom: 12 }}>
    <label style={{ display: "block", fontSize: 11, fontWeight: 700, color: "#888", textTransform: "uppercase", letterSpacing: "0.05em", marginBottom: 4 }}>{label}</label>
    {children}
  </div>
);

export default ProspeccionGenerarSolicitudModal;
